module.exports = __webpack_public_path__ + "static/img/novapozajmica.a75745e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/novapozajmica.png
// module id = OFe+
// module chunks = 0